export class ModelCodeFilter {

  modelCode: string;
  validFrom: string;
  validTo: string;
  orderBy: string;
  order: string;
  page = 0;
  pageSize = 20;
}
